import { MiraLogo } from "@recruiter/shared";

import { useSellerStore } from "../../lib/store/seller-store";
import { DebugToggle } from "../seller/debug-toggle";
import { SellerSwitcher } from "../seller/seller-switcher";

// The rail while no talent is picked (the tester's project directory): the brand, the
// "act as talent" switcher, and the debug toggle. Once a talent is chosen the rail goes and
// the talent's page (`TalentPage`) takes the whole width.
export function DirectoryRail() {
  const activeSellerId = useSellerStore((s) => s.activeSellerId);
  const setActiveSeller = useSellerStore((s) => s.setActiveSeller);
  const clearActiveSeller = useSellerStore((s) => s.clearActiveSeller);

  return (
    <aside className="sl-rail" aria-label="Talent sidebar">
      <div className="sl-rail__brand">
        <span className="sl-rail__home">
          <MiraLogo variant="solo" className="sl-rail__logo" title="Mira" />
          <span className="sl-rail__tag">for talent</span>
        </span>
      </div>
      <p className="sl-rail__intro">
        The talent test platform. Pick a talent from a project, or type the id the client
        shortlisted, and see everything Mira brought them.
      </p>
      <SellerSwitcher
        sellerId={activeSellerId}
        onSwitch={setActiveSeller}
        onBrowse={clearActiveSeller}
      />
      <div className="sl-rail__foot">
        <DebugToggle />
      </div>
    </aside>
  );
}
